<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :modal="false"
    custom-class="custom-dialog"
    width="800px"
  >
    <div slot="title" class="title">
      <div class="title-name">预览视频</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="onCancel">X</div>
    </div>
    <div v-if="dialogVisible" class="dialog-content">
      <iframe
        id="iframe"
        :src="url"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        allowtransparency="yes"
      />
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" style="margin-right:20px;background-color: #ccced3;border-color: #ccced3;" @click="onCancel">取 消</el-button>
      <el-button size="small" type="primary" class="custom-primary-plain" @click="onConfirm"
        >确 定</el-button
      >
    </span> -->
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      videoMap: {
        打标签: 'https://vod.aconsulting.top/sv/18d7ba09-1751b2f1453/18d7ba09-1751b2f1453.mp4',
        项目详情: 'https://vod.aconsulting.top/sv/7653c0e-1751b2f1453/7653c0e-1751b2f1453.mp4',
        推荐报告: 'https://vod.aconsulting.top/sv/4b562077-1751b481606/4b562077-1751b481606.mp4',
        面试安排面试辅导: 'https://vod.aconsulting.top/sv/4de7beb1-1751f868337/4de7beb1-1751f868337.mp4',
        mapping: 'https://vod.aconsulting.top/sv/360f8b29-1751fc7c4fd/360f8b29-1751fc7c4fd.mp4',
        离职辅导: 'https://vod.aconsulting.top/sv/1cb9e700-1751f86d7f6/1cb9e700-1751f86d7f6.mp4',
        背景调查: 'https://vod.aconsulting.top/sv/428f6b1b-1751fc7c503/428f6b1b-1751fc7c503.mp4',
      },
      url: '',
    }
  },
  async mounted() {
    this.user = app.user.account
  },
  methods: {
    open(type) {
      const { videoMap } = this
      if (!videoMap[type]) return this.$message.error('该类别没有关联附件')
      this.url = videoMap[type]
      this.dialogVisible = true
    },
    onCancel() {
      this.dialogVisible = false
    },
  },
}
</script>
<style src="../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.dialog-content {
  height: 600px;
}
</style>
